import { Avatar, rem } from "@mantine/core";
import { Spotlight } from "@mantine/spotlight";
import { IconSearch, IconUsers } from "@tabler/icons-react";
import { useContext, useMemo } from "react";

import { useGetEvents } from "../../api/event";
import { useUpdateUser } from "../../api/user";
import { AuthContext } from "../../services/context";
import updateConfig, { getCurrentWorkspace } from "../../services/userConfig";

export function SpotlightSwitcher() {
  const { user, setUser } = useContext(AuthContext);
  const { mutate } = useUpdateUser({
    id: user?.id,
    config: { hideNotification: true },
  });

  const currentWorkspace = getCurrentWorkspace(user);
  const { data: eventsData } = useGetEvents({
    workspace: currentWorkspace?.id,
  });

  const actions = useMemo(() => {
    const eventActions = (eventsData?.data || []).map((event) => ({
      id: `event-${event.id}`,
      label: event.name,
      description: "Switch to this event",
      onClick: () => {
        updateConfig({
          workspace: currentWorkspace,
          user,
          setUser,
          mutate,
          eventId: event.id,
        });
      },
      leftSection: (
        <Avatar
          src={event.config.logoImage}
          size={24}
          radius="sm"
          color={event?.config?.accentColor || "blue"}
        >
          {event.name.charAt(0).toUpperCase()}
        </Avatar>
      ),
      group: "Events",
    }));

    // If user has more than one workspace, we want to show available workspaces
    const workspaceActions = (
      user?.workspaces.length > 1 ? user.workspaces : []
    ).map((ws) => ({
      id: `ws-${ws.id}`,
      label: ws.name,
      description: "Switch to this workspace",
      onClick: () => {
        updateConfig({
          workspace: ws,
          user,
          setUser,
          mutate,
        });
      },
      leftSection: (
        <IconUsers style={{ width: rem(24), height: rem(24) }} stroke={1.5} />
      ),
      group: "Workspaces",
    }));

    return [...eventActions, ...workspaceActions];
  }, [eventsData, user, currentWorkspace, mutate, setUser]);

  return (
    <Spotlight
      actions={actions}
      nothingFound="Nothing found..."
      highlightQuery
      searchProps={{
        leftSection: (
          <IconSearch
            style={{ width: rem(20), height: rem(20) }}
            stroke={1.5}
          />
        ),
        placeholder: "Search events or workspaces...",
      }}
    />
  );
}
